// External libraries
import React from 'react';
import styled from 'styled-components';

// Zocdoc libraries
import { navy } from '@zocdoc/branding/colors';
import { filterToValidAttributes } from '@zocdoc-frontend-common/utils-dom-property';

// Icon code
import { Icon } from './_base';

const RescheduledSVG = styled(Icon).attrs({ viewBox: '0 0 38 40' })`
    width: 0.95em;
`;

const Rescheduled = ({ color = navy, ...props }) => (
    <RescheduledSVG
        data-test="icon-rescheduled"
        {...filterToValidAttributes(props)}
    >
        <path
            d="M21.53,3.14V0H16.47V3.14A18.52,18.52,0,1,0,21.53,3.14ZM19,35.63A14.15,14.15,0,1,1,33.15,21.48,14.16,14.16,0,0,1,19,35.63Z"
            fill={color}
        />
        <rect fill={color} height="4.37" width="4.74" x="16.17" y="26.22" />
        <rect fill={color} height="10.94" width="4.37" x="16.36" y="13.13" />
    </RescheduledSVG>
);

export { Rescheduled as default, Rescheduled };
